import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";

@Component({
    selector: 'app-scene-block-input',
    templateUrl: './block-input.component.html',
    styleUrls: ['./block-input.component.scss']
})
export class BlockInputComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.defaultValue', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "defaultValue",
                storePath: 'Data[0].TextInput[0].$.defaultValue'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.softKeyboard', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "softKeyboard",
                storePath: 'Data[0].TextInput[0].$.softKeyboard'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.fieldName', {}, this.translocoService.getActiveLang()),
                name: "fieldName",
                inputType: "text",
                storePath: 'Data[0].TextInput[0].$.fieldName'
            }
        ];
    }
}

